export interface IExplorerParams {
  address: string,
  id: string
}

export enum EExplorerPathnames {
  addressPathname = '/address/:address',
  transactionPathname = '/tx/:id',
}
